import { getBucket } from '@mc/experiments'

// https://app.growthbook.io/features/monitoring-console-logging-enabled
export const MONITORING_CONSOLE_LOGGING_FLAG =
  'monitoring-console-logging-enabled'

export const isConsoleLoggingEnabled = () =>
  getBucket(MONITORING_CONSOLE_LOGGING_FLAG) === 'on'
